import React from 'react';
import { Button } from 'ra-ui-materialui';
import { Edit as EditIcon } from '@material-ui/icons';
import '../../styles.css';

export default ({ push, basePath, data }) => {
  const handleClick = async () => push(`${basePath}/${data.id}/`);
  return (
    <Button
      variant="contained"
      label="Edit User"
      style={{ width: '100%', marginTop: 4 }}
      className="blueGray userActionButton"
      onClick={handleClick}
    >
      <EditIcon />
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/User/actions/actions/EditUserButton.jsx